'use strict';

import EcsInteractionWindow from '@/components/ecs-window/EcsInteractionWindow';
import { RESTORED, MAXIMIZED, MINIMIZED } from '@/constants/windowConstants';

const getInteractionWindow = state => interactionId => {
  const interactionWindow = state.windows.interaction.find(window => window.interactionId === interactionId);

  if (interactionWindow) {
    const {
      interactionId,
      state: { current: currentState, previous: previousState }
    } = interactionWindow;

    return new EcsInteractionWindow(interactionId, currentState, previousState);
  } else {
    return null;
  }
};

const getOpenWindowsInteractionIds = state => {
  return state.windows.interaction
    .filter(window => window.state.current === RESTORED || window.state.current === MAXIMIZED)
    .map(window => window.interactionId);
};

const getMinimizedWindowsInteractionIds = state => {
  return state.windows.interaction
    .filter(window => window.state.current === MINIMIZED)
    .map(window => window.interactionId);
};

const focusedInteractionId = state => state.windows.focusedInteractionId;

export default {
  getInteractionWindow,
  getOpenWindowsInteractionIds,
  getMinimizedWindowsInteractionIds,
  focusedInteractionId
};
